import { Plus, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { CustomInstallment } from '@/hooks/finance/usePaymentAgreements';

interface CustomInstallmentsTableProps {
  installments: CustomInstallment[];
  onUpdate: (index: number, field: 'amount' | 'due_date', value: number | string) => void;
  onRemove: (index: number) => void;
  onAdd: () => void;
  currency?: 'USD' | 'BRL';
}

export function CustomInstallmentsTable({
  installments,
  onUpdate,
  onRemove,
  onAdd,
  currency = 'USD',
}: CustomInstallmentsTableProps) {
  const currencySymbol = currency === 'BRL' ? 'R$' : 'US$';

  return (
    <div className="space-y-3">
      <div className="border rounded-lg overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-muted/50">
              <TableHead className="w-12 text-center">#</TableHead>
              <TableHead className="w-[45%]">Valor</TableHead>
              <TableHead>Data Vencimento</TableHead>
              <TableHead className="w-12"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {installments.map((installment, index) => (
              <TableRow key={index}>
                <TableCell className="text-center font-medium text-muted-foreground">
                  {index + 1}
                </TableCell>
                <TableCell>
                  <div className="flex items-center gap-1">
                    <span className="text-sm text-muted-foreground">{currencySymbol}</span>
                    <Input
                      type="number"
                      step="0.01"
                      min="0"
                      value={installment.amount || ''}
                      onChange={(e) => onUpdate(index, 'amount', parseFloat(e.target.value) || 0)}
                      className="h-8"
                    />
                  </div>
                </TableCell>
                <TableCell>
                  <Input
                    type="date"
                    value={installment.due_date}
                    onChange={(e) => onUpdate(index, 'due_date', e.target.value)}
                    className="h-8"
                  />
                </TableCell>
                <TableCell>
                  <Button
                    type="button"
                    variant="ghost"
                    size="icon"
                    className="h-8 w-8 text-destructive hover:text-destructive hover:bg-destructive/10"
                    onClick={() => onRemove(index)}
                    disabled={installments.length <= 1}
                  >
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <Button
        type="button"
        variant="outline"
        size="sm"
        className="w-full"
        onClick={onAdd}
      >
        <Plus className="h-4 w-4 mr-2" />
        Adicionar parcela
      </Button>
    </div>
  );
}
